import React from "react"
import LoginSection from "../sections/LoginSection"
import ResetPasswordComponent from "../components/ResetPasswordComponent"
import {RouteComponentProps} from "react-router"

type Params = {
    userID: string,
    hash: string,
}

const links = []

const ResetPasswordPage = (props: RouteComponentProps<Params>) => {

    return (
        <LoginSection links={links}>
            <ResetPasswordComponent
                {...props.match.params}
            />
        </LoginSection>
    )

}

export default ResetPasswordPage


// WEBPACK FOOTER //
// ./src/auth/pages/ResetPasswordPage.tsx